import 'bootstrap';



import '../../components/preloader/preloader';

import '../../font-service/font-service';


import '../../components/navi-bootstrap-offcanvas/navi-bootstrap-offcanvas';
import '../../components/navi-desktop-bootstrap/navi-desktop-bootstrap';
import { NavSwitcherSections } from '../../components/NavSwitcherSections/NavSwitcherSections';
import { PageNavScrollTrigger } from '../../components/PageNavScrollTrigger/PageNavScrollTrigger';
import { ResponsiveIframesInBlog } from '../../components/ResponsiveIframesInBlog/ResponsiveIframesInBlog.js';

import '../../components/EmergingImages/EmergingImages';
import { RaiserLetters } from '../../components/RaiserLetters/RaiserLetters';

import '../../components/sharing/sharing';

import '../../components/smooth-scrolling/smooth-scrolling.js';

import '../../components/video/video'
import '../../font-service/font-service';



import lazySizes from 'lazysizes';

import {
    detectMobile,
    isIE
} from '../../components/browser-detection/browser-detection.js';
import 'objectFitPolyfill/dist/objectFitPolyfill.basic.min';
// Global Styles

import './scss/single-post.scss';



const navSwitchting = new NavSwitcherSections();
const pageNav = new PageNavScrollTrigger();
const raiserLetters = new RaiserLetters();
new ResponsiveIframesInBlog()









